export default __webpack_public_path__ + "static/media/polygon.131a781d.svg";